import React, { useContext } from 'react';
import { Breadcrumbs, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { NavigationContext } from '../../../context/NavigationContext';

const breadcrumbStyle = {
  WebkitFontSmoothing: 'antialiased',
  boxSizing: 'border-box',
  color: '#30363C',
  cursor: 'pointer',
  flex: '0 1 auto',
  fontFamily: 'proxima-nova, "Arial CE", Arial, sans-serif',
  fontSize: '16px',
  fontWeight: '700',
  lineHeight: '24px',
  m: 0, // shorthand for margin
  maxWidth: '100%',
  minWidth: 0,
  p: 0, // shorthand for padding
  textAlign: 'left',
  textDecoration: 'none',
  textTransform: 'none',
};

const StyledLink = styled(Link)`
  &:hover {
    color: #30363C; // Set to the same color as the link text to "remove" hover effect
  }

  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
  color: #30363C;
  cursor: pointer;
  flex: 0 1 auto;
  font-family: proxima-nova, "Arial CE", Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
  max-width: 100%;
  min-width: 0;
  padding: 0;
  text-align: left;
  text-decoration: none;
  text-transform: none;
`;
const findBreadcrumbDetails = (categories, pathSegments, currentIndex = 0, accumulator = {
  isClickable: false,
  icon: null,
  name: '',
}) => {
  // Base case: if all segments have been processed
  if (currentIndex >= pathSegments.length) return accumulator;

  const segment = pathSegments[currentIndex];
  for (const category of categories) {
    if (category.path === segment) {
      // Update accumulator with details found at this level
      accumulator.isClickable = !!category.component;
      accumulator.icon = category.icon || accumulator.icon;
      accumulator.name = category.name;

      // If this category has children, dive deeper
      if (category.children && currentIndex < pathSegments.length - 1) {
        return findBreadcrumbDetails(category.children, pathSegments, currentIndex + 1, accumulator);
      } else {
        return accumulator; // No deeper to go, or this is the last segment
      }
    }
  }

  // Segment not matched in this branch of the tree, or no more categories to check
  return accumulator;
};


const NavigationBreadcrumbs = () => {
  const location = useLocation();
  const categoryList = useContext(NavigationContext);

  const pathnames = location.pathname.split('/').filter(x => x);

  return (
    <Breadcrumbs aria-label='breadcrumb'>
      {/*<Link color="inherit" href="/" underline="hover">*/}
      {/*  <HomeIcon /> /!* Assuming you have a HomeIcon component *!/*/}
      {/*  Home*/}
      {/*</Link>*/}

      {pathnames.map((value, index) => {

        const toFirst = `/${pathnames.slice(0, 0 + 1).join('/')}`;

        const pathSegmentsFirst = toFirst.substring(1).split('/');
        const { isClickableFirst, iconFirst, nameFirst } = findBreadcrumbDetails(categoryList, pathSegmentsFirst);

        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;

        const pathSegments = to.substring(1).split('/');
        const { isClickable, icon, name } = findBreadcrumbDetails(categoryList, pathSegments);

        if (!name) {
          return null;
        }
        return (

            isClickable && false ? (
              <StyledLink color='inherit' to={to} underline='hover'>
                {((index === 0 && name) || (!nameFirst && index === 1)) && icon &&
                  React.cloneElement(icon, {
                    style: {
                      verticalAlign: 'middle', marginRight: '4px',
                      top: '-2px', size: '1em', fontSize: '20px',
                    }, size: '1em'
                  })}
                {name}
              </StyledLink>
            ) : (
              <Typography color='textPrimary' key={to} sx={{ ...breadcrumbStyle, cursor: 'default' }}>

                {((index === 0 && name) || (!nameFirst && index === 1)) && icon &&
                  React.cloneElement(icon, {
                    style: {
                      verticalAlign: 'middle', marginRight: '4px', fontSize: '20px', position: 'relative',
                      top: '-2px',
                    }, size: '1em'
                  })}
                {name}
              </Typography>
            )

        );
      })}
    </Breadcrumbs>
  );
};

export default NavigationBreadcrumbs;